<template>
  <div class="">
    <div class="w-full mt-28 px-8">
      <Mybookings />
    </div>
  </div>
</template>

<script>
import Mybookings from "./components/Mybookings.vue";

export default {
  components: {
    Mybookings,
  },
};
</script>

<style></style>
